module.exports = __webpack_public_path__ + "static/media/UNP-RBLAC-UNDP-no-tagline.cab91b2c.png";